@if (extension$ | async; as extension) {
  <ng-container>
    <nexweb-extension-form
      [extension]="extension"
      [labels]="labels"
      [headings]="headings"
      [dateTimeFormat]="dateTimeFormat"></nexweb-extension-form>
  </ng-container>
}
